import { render } from "./TermsAndConditions.vue?vue&type=template&id=4b9546c4&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=4b9546c4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9546c4"]])

export default __exports__